<template lang="pug">
.bg-salt
  main.container-fluid
    router-view
  footer#footer
    .container.powered-by
      .d-flex.align-items-center.justify-content-center
        p.typo-paragraph12.typo-regular.mr-1 {{ $t("staticSite.powerBy") }}
        svg(width="97" height="15" viewBox="0 0 97 15" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(d="M29.6664 8.40122H27.0139V6.90763H31.3662V7.41172C31.3662 11.0617 28.9986 12.924 26.1873 12.924C23.1753 12.924 20.9805 10.7116 20.9805 7.68243C20.9805 4.65326 23.1753 2.44089 26.1827 2.44089C27.6397 2.44089 28.8912 2.95897 29.8065 3.81778L28.653 4.99398C28.0273 4.39188 27.168 4.01848 26.1873 4.01848C24.1326 4.01848 22.6336 5.62875 22.6336 7.68243C22.6336 9.75011 24.1326 11.3464 26.1873 11.3464C27.9946 11.3464 29.3628 10.1095 29.6664 8.40122ZM33.0333 12.7093V2.65559H38.0254V4.16784H34.6584V6.7256H38.0254V8.21919H34.6584V11.2157H38.0254V12.7093H33.0333ZM40.1642 2.65559H41.7893L44.7126 6.57624L47.5239 2.65559H49.149V12.7093H47.5239V5.45606L44.7126 9.23202L41.7893 5.45606V12.7093H40.1642V2.65559ZM55.7101 2.65559H58.9603C60.7442 2.65559 62.0144 3.80378 62.0144 5.58674C62.0144 7.35104 60.7442 8.5179 58.9603 8.5179H57.3352V12.7093H55.7101V2.65559ZM57.3399 4.22385V6.95431H58.8669C59.7215 6.95431 60.3099 6.43622 60.3099 5.59141C60.3099 4.7466 59.7262 4.22852 58.8669 4.22852H57.3399V4.22385ZM70.6629 12.7093H68.9211L67.7536 9.20402H64.7603L63.5461 12.7093H61.8043L65.4421 2.65559H67.1419L70.6629 12.7093ZM65.2693 7.69643H67.24L66.2686 4.81195L65.2693 7.69643ZM79.9186 8.40122H77.2661V6.90763H81.6184V7.41172C81.6184 11.0617 79.2508 12.924 76.4396 12.924C73.4275 12.924 71.2327 10.7116 71.2327 7.68243C71.2327 4.65326 73.4275 2.44089 76.4396 2.44089C77.8965 2.44089 79.1481 2.95897 80.0634 3.81778L78.9099 4.99398C78.2841 4.39188 77.4249 4.01848 76.4442 4.01848C74.3895 4.01848 72.8905 5.62875 72.8905 7.68243C72.8905 9.75011 74.3895 11.3464 76.4442 11.3464C78.2514 11.3464 79.6197 10.1095 79.9186 8.40122ZM83.2855 12.7093V2.65559H88.2776V4.16784H84.9107V6.7256H88.2776V8.21919H84.9107V11.2157H88.2776V12.7093H83.2855ZM94.227 5.28336C94.227 4.46656 93.7553 3.94847 92.9848 3.94847C92.2003 3.94847 91.6866 4.48056 91.6866 5.15267C91.6866 5.84345 92.0135 6.21685 92.9848 6.48756L93.4565 6.61825C95.1236 7.07566 96.3658 7.75244 96.3658 9.77811C96.3658 11.6031 94.9415 12.91 93.0128 12.91C91.1029 12.91 89.6879 11.6171 89.6879 9.54941H91.243C91.243 10.5996 91.9995 11.4024 93.0128 11.4024C94.0962 11.4024 94.7827 10.6976 94.7827 9.77811C94.7827 8.87263 94.213 8.44322 93.0268 8.11183L92.5832 7.99515C90.9301 7.53774 90.1456 6.58558 90.1456 5.15267C90.1456 3.5144 91.3597 2.43622 92.9848 2.43622C94.7547 2.43622 95.768 3.41171 95.768 5.27869L94.227 5.28336ZM50.9982 7.68243L52.4225 6.23085L53.8655 7.68243L52.4412 9.13401L50.9982 7.68243Z" fill="#9E9E9E")
          path(d="M12.785 0.504555L0.0689719 4.47188C0.0176037 4.48589 -0.0104155 4.5419 0.00359405 4.59791L0.984261 7.81378C0.998271 7.86512 1.05431 7.89779 1.10568 7.87912L10.436 4.96663C10.8797 4.82661 11.2579 4.51856 11.4727 4.09849C12.0518 2.98764 12.5328 1.83011 12.9017 0.630577C12.9297 0.55123 12.8597 0.481218 12.785 0.504555Z" fill="#9E9E9E")
          path(d="M9.73548 6.06751L1.8341 8.53193C1.79207 8.54593 1.76405 8.5926 1.77806 8.63928L2.60929 11.3557C2.6233 11.3977 2.67 11.4257 2.71203 11.4117L7.75079 9.83881C8.12905 9.72213 8.44193 9.45608 8.62872 9.10602C9.11906 8.16787 9.52533 7.1877 9.83354 6.17487C9.85689 6.10952 9.79618 6.04884 9.73548 6.06751Z" fill="#9E9E9E")
          path(d="M6.29521 11.1727L3.43726 12.0642C3.3999 12.0735 3.38122 12.1155 3.39056 12.1528L4.09104 14.4492C4.10038 14.4866 4.14241 14.5099 4.17977 14.4959L4.61873 14.3605C4.93628 14.2625 5.20246 14.0385 5.36124 13.7398C5.77685 12.9463 6.11775 12.1202 6.37926 11.2613C6.40261 11.2053 6.35125 11.154 6.29521 11.1727Z" fill="#9E9E9E")
</template>

<script>
import { /* mapActions, */ mapState, mapGetters } from "vuex";
// import Cookies from "@/utils/cookie.js";
import getLocale from "@/mixins/getLocale.js";
import Cookie from "@/utils/cookie";
import { GEM_LANG_COOKIE_NAME } from "@/config/constants/common";
// import { readI18n } from "@/i18n.js";

export default {
  name: "EmptyLayout",
  components: {},
  mixins: [getLocale],
  data() {
    return {};
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    ...mapGetters("account", {
      accountExpired: "accountExpired"
    }),
    shopDomainURL() {
      return `https://${this.shopInfo.shopifyDomain}`;
    }
  },
  created() {
    // this.whoAmI();
    this.$body = this.$refs.mainBody;
    this.checkLanguage();
  },
  mounted() {},
  methods: {
    // ...mapActions("account", {
    //   whoAmI: "accountWhoAmI",
    // }),
    isEmpty(value) {
      let _val = (value || "").trim();
      return !_val || !_val.length;
    },
    gotoUpgrade() {
      this.$router.replace({ name: "Pricing" });
    },
    checkLanguage() {
      if (this.shopInfo?.language && this.shopInfo?.language != "") {
        return;
      }
      const cookieLang = Cookie.get(GEM_LANG_COOKIE_NAME);
      if (cookieLang && cookieLang != "") {
        this.$i18n.locale = cookieLang;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
